import React from "react";
import { observer } from "mobx-react-lite";
import { ErrorWrapper } from "@features/offer/shared/statistics";
import {
	CorrectScoreStatistics,
	DoubleChanceStatistics,
	OverUnderByPeriod,
	FirstTeamToScoreStatistics,
	HandicapStatistics,
	OverUnderStatistics,
	ThreeWayStatistics,
	WhoWinsFirstHalfStatistics,
	WhoWinsSecondHalfStatistics,
	WillBothTeamsScoreStatistics,
} from "@features/offer/shared/statistics/components/betting-types";
import { TStatisticsBettingData } from "@data-types/offer/event-betting-type/StatisticsBettingData";

type StatisticsComponentProps = {
	homeTeam: any;
	awayTeam: any;
};

const statisticsComponents: {
	[key: string]: React.ComponentType<StatisticsComponentProps>;
} = {
	"3way": ThreeWayStatistics,
	"double-chance": DoubleChanceStatistics,
	"over-under": OverUnderStatistics,
	"who-wins-1st-half": WhoWinsFirstHalfStatistics,
	"who-wins-2nd-half": WhoWinsSecondHalfStatistics,
	"will-both-teams-score": WillBothTeamsScoreStatistics,
	"handicap-hcp": HandicapStatistics,
	"correct-score-score-max-6": CorrectScoreStatistics,
	"1st-half-totals": OverUnderByPeriod,
	"goalnr-goal": FirstTeamToScoreStatistics,
	"2nd-half-over-under": OverUnderByPeriod,
};

export default observer(function BettingTypeStatistics(props: {
	bettingTypeStats: TStatisticsBettingData | null;
	bettingTypeAbrv: string;
	setState?: Function;
}) {
	if (
		!props.bettingTypeStats ||
		props.bettingTypeStats.action != "stats" ||
		!props.bettingTypeStats.data ||
		props.bettingTypeStats?.data?.length == 0
	) {
		return null;
	}

	const homeTeamData = props.bettingTypeStats.data?.[0]?.data;
	const awayTeamData = props.bettingTypeStats.data?.[1]?.data;

	const SpecificStatisticsComponent =
		statisticsComponents[props.bettingTypeAbrv];

	if (!SpecificStatisticsComponent) {
		return null;
	}

	return (
		<ErrorWrapper>
			<SpecificStatisticsComponent
				homeTeam={homeTeamData}
				awayTeam={awayTeamData}
			/>
		</ErrorWrapper>
	);
});
